import { render, staticRenderFns } from "./PassengerFindDetails.vue?vue&type=template&id=1bffc090&scoped=true&"
import script from "./PassengerFindDetails.vue?vue&type=script&lang=js&"
export * from "./PassengerFindDetails.vue?vue&type=script&lang=js&"
import style0 from "./PassengerFindDetails.vue?vue&type=style&index=0&id=1bffc090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bffc090",
  null
  
)

export default component.exports